import { ReactComponent as LogsSvg } from "../../assets/images/svgs/logs.svg";

const LogsIcon = ({ className = "", ...props }) => {
  return (
    <LogsSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default LogsIcon;
